import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'ui/layout/Modal'
import { ConfirmContent } from 'ui/partials/ConfirmContent'

const timeout = 1000 * 10

const useZoomTemporaryErrorModal = ({
  onReconnect,
}: {
  /**
   * モーダルが表示された際にインターバルタイマーで発火する関数
   */
  onReconnect: () => void
}): {
  /**
   * エラー発生時に発火させる
   */
  openZoomTemporaryErrorModal: () => void
  /**
   * エラーをリセットした時に閉じる
   */
  closeZoomTemporaryErrorModal: () => void
  /**
   * この変数をjsx内に配置するとモーダルが表示される
   */
  zoomTemporaryErrorModalComponent: React.ReactNode
} => {
  const { t } = useTranslation()
  const [showZoomConnectionErrorModal, setShowZoomConnectionErrorModal] =
    useState<boolean>(false)

  useEffect(() => {
    if (showZoomConnectionErrorModal) {
      const timer = setTimeout(() => {
        onReconnect()
      }, timeout)
      return () => clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showZoomConnectionErrorModal])

  const zoomTemporaryErrorModalComponent = (
    <Modal
      open={showZoomConnectionErrorModal}
      handleClose={() => setShowZoomConnectionErrorModal(false)}
    >
      <ConfirmContent
        onSubmit={() => setShowZoomConnectionErrorModal(false)}
        submitLabel={t('閉じる')}
        title={`${t('errors.現在一時的にZoomへの接続ができません。')}${t(
          'errors.再接続を行いますのでこのまましばらくお待ちください。'
        )}`}
      />
    </Modal>
  )
  return {
    openZoomTemporaryErrorModal: () => setShowZoomConnectionErrorModal(true),
    closeZoomTemporaryErrorModal: () => setShowZoomConnectionErrorModal(false),
    zoomTemporaryErrorModalComponent,
  }
}

export default useZoomTemporaryErrorModal
